import React from "react";
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <div className="py-[10px]">
      <p className="uppercase text-[18px] font-cormorant">{t("CONTACT")}</p>
      <p className="bg-gray-200 border-[1px] mt-[10px] mb-[40px]"></p>
      <div className="bg-gray-200 py-[15px] px-[35px] ">
        <h3 className="text-[30px] font-cormorant">{t("INFOR_CONTACT")}</h3>
        <div className="">
          <ul className="space-y-4 text-black">
            {/* Hotline */}
            <li className="flex items-center gap-2">
              <i class="fa fa-volume-control-phone"></i>
              <span>02773.872.839</span>
            </li>
            <li className="flex items-center gap-2">
              <p>Hotline:</p>
              <span>0586.70.68.68</span>
            </li>
            {/* Email */}
            <li className="flex items-center gap-2">
              <i class="fa fa-envelope" aria-hidden="true"></i>
              <span>devuong01.hotel@gmail.com</span>
            </li>

            {/* Hotel Name */}
            <li className="flex items-center gap-2">
              <i class="fa fa-location-arrow" aria-hidden="true"></i>
              <span className="uppercase">{t("HOTEL_NAME")}</span>
            </li>

            {/* Address */}
            <li className="flex items-start">
              <span>{t("ADDRESS")}</span>
            </li>
          </ul>
        </div>
        <div className="mt-4 w-full shadow-lg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.5732564842235!2d105.6487803!3d10.4565167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310a6456d8b0f71b%3A0x7bdeef1ea238540d!2zS2jDoWNoIHPhu5FuIMSQ4bqjIFbGsMahbmcgMg!5e0!3m2!1svi!2s!4v1684302282540!5m2!1svi!2s"
            width="100%"
            height="300"
            style={{ border: "0" }}
            allowFullScreen
            loading="lazy"
            title="Location of ĐẾ VƯƠNG"
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
